import { render, staticRenderFns } from "./ReceiptTransactionDetails.vue?vue&type=template&id=0cbbb860&scoped=true&"
import script from "./ReceiptTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./ReceiptTransactionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptTransactionDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReceiptTransactionDetails.vue?vue&type=style&index=1&id=0cbbb860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbbb860",
  null
  
)

export default component.exports